import React, { useState, useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {IconButton, InputAdornment, Typography } from "@mui/material";

import ClearIcon from '@mui/icons-material/Clear';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const SelectBoxField = ({ label, options = [], isRequired, onChange, value, sx, ClearFunc, isloading, type, isShowCross = true, noOptionsText, ...props }) => {
    const [open, setOpen] = useState(false);
    const [selectedOption, setSelectedOption,] = useState(null);
    const [inputValue, setInputValue] = React.useState("");
    useEffect(() => {
        if (typeof value === "object" && value !== null) {
            setSelectedOption(value);
        }

    }, [value, options]);

    const handleChange = (_, newValue) => {
        if (type === "date") {
            setSelectedOption(newValue);
            onChange(newValue ? newValue.value : "");
        } else {
            if (newValue) {
                setSelectedOption(newValue);
                onChange(newValue.id);
            }
        }

    };

    const handleClear = (event) => {
        event.stopPropagation();
        setSelectedOption(null);
        onChange("");
        if (ClearFunc) ClearFunc();

    };

    return (
        <FormControl fullWidth>
            <Autocomplete
                id="autocomplete"
                options={isloading ? [] : options}
                getOptionLabel={(option) => option.label}
                value={selectedOption}
                onChange={handleChange}
                inputValue={inputValue}
                onInputChange={(_, newValue, reason) => {
                    setInputValue(newValue);
                    if (props.isShow && reason === 'input') {
                        setOpen(newValue.length >= 3); // Only show after typing 3+ characters
                    }
                    if (reason === "input") {
						props.onSearchChange?.(newValue);
					}
                }}

                open={props.isShow ? open : undefined}

                onOpen={() => {
                    if (!props.isShow) setOpen(false);
                }}
                onClose={() => {
                    if (props.isShow) setOpen(false);
                }}
                // filterOptions={(opts) => opts}
                filterOptions={(options, { inputValue }) =>
                    options.filter(option => option.label.toLowerCase().includes(inputValue.toLowerCase()))
                }
                isOptionEqualToValue={(option, val) => typeof value === "object" ? option.value === val?.value : option.id === val?.id}
                loading={isloading}

                sx={{
                    backgroundColor: "#ECECEC",
                    borderRadius: 1,
                   
                    "& fieldset": { border: "none" },
                    "& .MuiOutlinedInput-root .MuiAutocomplete-input": { padding:0.5 },
                    "& .MuiInputBase-input": { fontSize: "16px" },
                    "& .MuiAutocomplete-endAdornment": {
                        display: props.isShow ? "none !important" : "block !important",
                    },
                    ...sx
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder={label}
                        required={isRequired}
                        slotProps={{
                            input: {
                                ...params.InputProps,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {selectedOption && isShowCross && (
                                            <IconButton onClick={handleClear} size="small">
                                                <ClearIcon sx={{ fontSize: "18px" }} />
                                            </IconButton>
                                        )}
                                        {/* <IconButton
                                            onClick={() => {
                                                if (!props.isShow || inputValue.length >= 3) {
                                                    setOpen(!open);
                                                }
                                            }}
                                            size="small"
                                        >
                                            <KeyboardArrowDownIcon  sx={{ fontSize: "24px" }} />
                                        </IconButton> */}
                                    </InputAdornment>
                                ),
                            }
                        }}
                    />
                )}
                renderOption={(props, option) => (
                    <li {...props}>  <Typography variant="body2">{option.label}</Typography></li>
                )}
                noOptionsText={isloading ? <Typography variant="body2">Loading......</Typography> : <Typography variant="body2">{noOptionsText || "No Option"}</Typography>}
            />
        </FormControl>
    );
};

export default SelectBoxField;
